import { getUserSystem } from "@/api/home";
import { getPaymentCount } from "@/api/payment";
import { getTerminalType } from '@/utils'

const systems = {
  state: {
    systemList: [],
    systemType: 'pc',
    systemId: 49,
    cooperationType: 0, // 院校合作
    isSafing: false,
    pageType: '',
    pageCode: '',
    shellId: null,
    userId: null,
    payNum: 0
  },
  mutations: {
    SETPAGETYPE(state, val) {
      state.pageType = val
    },
    SETPAGECODE(state, val) {
      state.pageCode = val
    },
    SET_ISSAFING: (state, val) => {
      state.isSafing = val
    },
    SET_SYSTEMID: (state, val) => {
      state.systemId = val
    },
    SET_COOTYPE: (state, val) => {
      state.cooperationType = val
    },
    SET_SHELLID: (state, val) => {
      state.shellId = val
    },
    SET_USERID: (state, val) => {
      state.userId = val
    },
    SET_SYSTEMLIST: (state, list) => {
      state.systemList = list
    },
    SET_systemType: (state, type) => {
      state.systemType = type
    },
    SET_PAYNUM: (state, val) => {
      state.payNum = val
    }
  },
  actions: {
    setSafe({ commit }, val) {
      return new Promise(resolve => {
        commit('SET_ISSAFING', val) // 开发用
        resolve()
      })
    },
    setSystemId({ commit }, val) {
      return new Promise(resolve => {
        commit('SET_SYSTEMID', val) // 开发用
        resolve()
      })
    },
    getSystem({ commit }) {
      return new Promise(resolve => {
        getUserSystem().then(res => {
          commit('SET_SYSTEMLIST', res.data)
          if (res.data.length === 1 && res.data[0].list.length === 1) {
            resolve(res.data[0].list[0])
          } else {
            resolve(false)
          }
        })
      })
    },
    getSystemType({ commit }) {
      return new Promise(resolve => {
        getTerminalType().then(res => {
          commit('SET_systemType', res)
          resolve(res)
        })
      })
    },
    getPayNum({ commit }, query) {
      return new Promise(resolve => {
        getPaymentCount(query).then(res => {
          commit('SET_PAYNUM', res.data)
          resolve(res.data)
        })
      })
    }
  }
}

export default systems
